import { IHttpApi } from '@cian/http-api';
import { registerEndpointRequest } from '../../shared/api/registerEndpoint';
import { setSubscriptionData } from '../../shared/utils/localStorage/storage';

export async function registerEndpoint(httpApi: IHttpApi, subscription: PushSubscription, fromPopup?: boolean) {
  const response = await registerEndpointRequest(httpApi, subscription, fromPopup);
  if (response.statusCode === 200) {
    setSubscriptionData(response.response.userId);
  } else {
    throw new Error(response.response.message);
  }
}
